import React from "react";
import PropTypes from "prop-types";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import colors from "styles/tokens/colors";

function PackagesTab({ catalogue }) {
  const published = catalogue.filter((entry) => entry.is_published);
  return (
    <Card sx={{ p: { xs: 2, md: 3 }, border: `1px solid ${colors.border.default}` }}>
      <MDTypography variant="h6">Packages on this website</MDTypography>
      <MDTypography variant="body2" color="text" mb={2}>
        Publish packages from each Trip Package page. This list is a summary of what customers can already see.
      </MDTypography>
      <Grid container spacing={1}>
        {published.map((entry) => (
          <Grid item xs={12} md={6} key={entry.id}>
            <MDBox p={1.25} sx={{ border: `1px solid ${colors.border.default}`, borderRadius: 2 }}>
              <MDTypography variant="button" fontWeight="medium">Package #{entry.trip_package_id}</MDTypography>
              <MDTypography variant="caption" display="block" color="text">/{entry.public_slug || `package-${entry.trip_package_id}`}</MDTypography>
            </MDBox>
          </Grid>
        ))}
        {!published.length && (
          <Grid item xs={12}>
            <MDTypography variant="body2" color="text">No packages have been published yet. Open a Trip Package and select Publish to website.</MDTypography>
          </Grid>
        )}
      </Grid>
    </Card>
  );
}

PackagesTab.propTypes = { catalogue: PropTypes.arrayOf(PropTypes.object).isRequired };

export default PackagesTab;
